import React from 'react';

// ============================================================================
// Skeleton — in-place loading blocks (Design Constitution §4 Feedback: F05, C20)
// ----------------------------------------------------------------------------
// After the header renders, a loading section, column or tile shows gray
// skeleton bars where its content will sit (no spinner, no "Loading…" text).
//   <Skeleton />                     one text-height bar
//   <Skeleton lines={3} />           a short paragraph
//   <Skeleton height={64} radius={18} />  a tile placeholder
// The bars pulse gently; reduced motion keeps them still (T10). Screen readers
// hear one polite 'Loading' instead of the bars.
// ============================================================================

type SkeletonProps = {
  lines?: number;
  width?: number | string;
  height?: number;
  radius?: number;
  label?: string;
  style?: React.CSSProperties;
};

export default function Skeleton({
  lines = 1,
  width = '100%',
  height = 14,
  radius = 10,
  label = 'Loading',
  style,
}: SkeletonProps) {
  return (
    <div role="status" aria-label={label} data-skeleton style={{display: 'grid', gap: 8, ...style}}>
      {Array.from({length: Math.max(1, lines)}, (_, i) => (
        <span
          key={i}
          className="wcf-skeleton"
          aria-hidden="true"
          style={{
            display: 'block',
            height,
            borderRadius: radius,
            // The last line of a paragraph is shorter, like real text.
            width: lines > 1 && i === lines - 1 ? '60%' : width,
          }}
        />
      ))}
    </div>
  );
}
